class MainColelction extends HTMLElement {
  constructor() {
    super();
    this.quickViewModal = document.querySelector(".quick-view-modal");
    this.quickViewClose = document.querySelector(
      ".quick-view-modal__close-icon"
    );
    this.loadingSpinner = document.querySelector(
      ".quick-view-modal__spinner-wrapepr"
    );
    this.productAddedIcon = document.querySelector(
      ".modal-product__check-icon"
    );
    this.loaderIocnAnimation = document.querySelector(
      ".modal-product__loader-icon"
    );
    this.submitFormBtn = document.querySelector(
      ".quick-view-modal__submit-btn"
    );

    this.product = null;
    this.variantId = null;

    this.initQuickView();
  }

  initQuickView() {
    const quickViewButtons = document.querySelectorAll(
      ".main-collection__quick-view-button"
    );

    quickViewButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        document.body.style.overflow = "hidden";
        this.quickViewModal.classList.add("active");

        this.loadingSpinner.style.display = "block";
        this.productAddedIcon.style.display = "none";
        this.loaderIocnAnimation.style.display = "none";

        const productHandle = button.getAttribute("data-product-handle");
        const productMetaInfo = button.getAttribute("data-product-info");
        fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
          .then((response) => response.json())
          .then((data) => {
            this.product = data;
            this.variantId = this.product.variants[0].id;
            this.updateModalContent(this.product, productMetaInfo);
            setTimeout(() => {
              this.loadingSpinner.style.display = "none";
            }, 500);
          })
          .catch((error) => {
            console.error("Error fetching product:", error);
            setTimeout(() => {
              this.loadingSpinner.style.display = "none";
            }, 500);
          });
      });
    });

    if (this.quickViewClose) {
      this.quickViewClose.addEventListener("click", () => this.closeModal());
    }

    this.quickViewModal.addEventListener("click", (e) => {
      if (e.target === this.quickViewModal) {
        this.closeModal();
      }
    });
  }

  updateModalContent(product, productMetaInfo) {
    console.log(productMetaInfo);  
    document.querySelector(".modal-product__title").innerText = product.title;
    document.querySelector(".modal-product__image").src = product.images[0];
    document.querySelector(".modal-product__price").innerText =
      Shopify.formatMoney(product.price);
    
    const sku =
      product.variants && product.variants.length > 0 && product.variants[0].sku.length !== 0
        ? product.variants[0].sku
        : "N/A";
    document.querySelector(".modal-product__sku").innerText = `${sku}`;
    document.querySelector(".modal-product__vendor").innerText = product.vendor;
    document.querySelector(".main-product__additional-info").innerText = productMetaInfo;

    this.initializeQuantityControls();
  }

  initializeQuantityControls() {
    const quantityInput = document.getElementById("product-quantity");
    const increaseButton = document.getElementById("increase-quantity");
    const decreaseButton = document.getElementById("decrease-quantity");
    const form = document.getElementById("quick-view-form");

    quantityInput.value = 1;

    increaseButton.replaceWith(increaseButton.cloneNode(true));
    decreaseButton.replaceWith(decreaseButton.cloneNode(true));

    const newIncreaseButton = document.getElementById("increase-quantity");
    const newDecreaseButton = document.getElementById("decrease-quantity");

    newIncreaseButton.addEventListener("click", () => {
      quantityInput.value = parseInt(quantityInput.value) + 1;
    });

    newDecreaseButton.addEventListener("click", () => {
      if (quantityInput.value > 1) {
        quantityInput.value = parseInt(quantityInput.value) - 1;
      }
    });

    if (form) {
      form.addEventListener("submit", (submitEvent) => {
        submitEvent.preventDefault();
        const quantity = parseInt(quantityInput.value);
        this.addToCart(this.variantId, quantity);
      });
    }
  }

  addToCart(variantId, quantity) {
    this.submitFormBtn.setAttribute("disabled", "");
    this.showLoadingSpinner();

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        this.productAdded();
        this.hideLoadingSpinner();
        return response.json();
      })
      .then(() => {
        this.updateCartCount();
      })
      .catch((error) => {
        this.hideLoadingSpinner();
        console.error("Error adding product to cart:", error);
      });
  }

  updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountBubble = document.querySelector(".cart-count-bubble");
        cartCountBubble.innerText = cart.item_count;
        cartCountBubble.style.display = "flex";
      })
      .catch((error) => {
        console.error("Error fetching cart count:", error);
      });
  }

  productAdded() {
    this.productAddedIcon.style.display = "block";

    setTimeout(() => {
      this.productAddedIcon.style.display = "none";
    }, 1000);
  }

  showLoadingSpinner() {
    this.productAddedIcon.style.display = "none";
    this.loaderIocnAnimation.style.display = "block";
  }

  hideLoadingSpinner() {
    this.submitFormBtn.removeAttribute("disabled");
    this.loaderIocnAnimation.style.display = "none";
  }

  closeModal() {
    const quantityInput = document.getElementById("product-quantity");
    this.quickViewModal.classList.remove("active");
    document.body.style.overflow = "auto";
    quantityInput.value = 1;
    this.variantId = null;
  }
}

customElements.define("main-collection", MainColelction);
